import { useTranslation } from "react-i18next";
import { steps } from "@/mocks/landing";

export default function HowItWorks() {
  const { t } = useTranslation();
  return (
    <section id="how-it-works" className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
            {t("home.howItWorks.eyebrow")}
          </span>
          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-foreground-950">
            {t("home.howItWorks.title")}
          </h2>
          <p className="mt-4 text-foreground-600">
            {t("home.howItWorks.subtitle")}
          </p>
        </div>

        <div className="relative mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* connecting line */}
          <div className="hidden md:block absolute top-16 left-[16%] right-[16%] h-px bg-gradient-to-r from-primary-300 via-accent-300 to-primary-300"></div>

          {steps.map((step, i) => (
            <div
              key={step.titleKey}
              className="relative group bg-background-50 border border-background-200/70 rounded-2xl p-8 text-center transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="relative z-10 w-20 h-20 mx-auto flex items-center justify-center rounded-2xl bg-primary-50 text-primary-600 group-hover:bg-gradient-to-br group-hover:from-primary-500 group-hover:to-accent-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${step.icon} text-3xl`}></i>
                <span className="absolute inset-0 rounded-2xl ring-1 ring-primary-200/60 group-hover:ring-accent-300/60"></span>
              </div>

              <span className="absolute top-6 left-6 text-5xl font-bold text-background-200 select-none">
                {String(i + 1).padStart(2, "0")}
              </span>

              <h3 className="mt-6 text-xl font-bold text-foreground-950">{t(step.titleKey)}</h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t(step.descriptionKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}